import React from 'react';
import { string } from 'prop-types';

export default function BreakView({ breakLabel, breakClassName }) {
    return (
        <li className={breakClassName ? breakClassName : 'break disabled'}>
            <span>{breakLabel}</span>
        </li>
    );
}

BreakView.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    breakLabel: string.isRequired,
    breakClassName: string.isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/pagination/BreakView.jsx